import * as R from "ramda";
import { Action } from "redux";
import { AppState } from "./appState";
import ACTION_TYPE from "./ActionTypes";
import { IFilterForm } from "./overagesFilterFormActions";


export type typeDamagesFilterForm = {
  type: ACTION_TYPE.DAMAGES_LIST_FILTER_FORM_STATE;
  damagesFilterForm: IFilterForm;
};

/**
 * Redux action to update DispatchForm in Redux State
 * @param damagesForm - the params we use for the dispatch api put request Obtained from DispatchForm component.
 */

export const saveDamagesFilterForm = (
    damagesFilterForm: IFilterForm
): typeDamagesFilterForm => ({
  type: ACTION_TYPE.DAMAGES_LIST_FILTER_FORM_STATE,
  damagesFilterForm: damagesFilterForm,
});

export const saveDamagesFilterFormReducer = (
  state: AppState,
  action: Action
): AppState => {
  if (action.type !== ACTION_TYPE.DAMAGES_LIST_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    damagesFilterForm: (action as typeDamagesFilterForm)
      .damagesFilterForm,
  });
};
